// triggerEvent.ts

export interface EventData {
  [key: string]: any;
}

export async function triggerEvent(
  eventType: string,
  data: EventData = {}
): Promise<{ success: boolean; error?: string }> {
  try {
    const response = await fetch(
      "https://romdrops-presignups-worker.romdropsapp.workers.dev/api/track-event",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ eventType, data }),
      }
    );

    if (response.ok) {
      return { success: true };
    } else {
      return {
        success: false,
        error: `Failed to record event: ${response.statusText}`,
      };
    }
  } catch (error) {
    console.error(`Error triggering event ${eventType}:`, error);
    return { success: false, error: "Network error occurred" };
  }
}
